import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { BaseResponse } from '../models/response/baseResponse';
import { map } from 'rxjs/operators';
import { DownloadLogStatus } from '../../../common/interfaces/DownloadLogStatus';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private httpClient = inject(HttpClient);
  private configService = inject(ConfigService);

  private apiLink: string;

  constructor() {
    /** ApiLink */
    this.apiLink = `${this.configService.config.apiEndpoint}`;
  }

  requireLog(codeVoucher: string): Observable<BaseResponse> {
    const url = `${this.apiLink}/log/require`;
    const params = new HttpParams().set('voucher_code', codeVoucher);

    return this.httpClient.get<BaseResponse>(url, { params });
  }

  checkLogIsReady(codeVoucher: string): Observable<DownloadLogStatus> {
    const url = `${this.apiLink}/log/ready`;
    const params = new HttpParams().set('voucher_code', codeVoucher);

    return this.httpClient
      .get<BaseResponse<DownloadLogStatus>>(url, {
        params
      })
      .pipe(map((res) => res.payload));
  }

  downloadLog(codeVoucher: string): Observable<{ blob: Blob; fileName: string }> {
    const url = `${this.apiLink}/log/download`;
    return this.httpClient
      .get(url, {
        headers: new HttpHeaders(),
        responseType: 'blob',
        params: new HttpParams().set('voucher_code', codeVoucher),
        observe: 'response'
      })
      .pipe(
        map((response: any) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          return {
            blob: response.body,
            fileName: this.getFilename(contentDisposition)
          };
        })
      );
  }

  private getFilename(contentDisposition: string | undefined): string {
    let fileName = `log_${new Date().getTime()}`;

    if (contentDisposition) {
      const regex = /filename=(.*).zip/;
      const fileNameMatch = contentDisposition.match(regex);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1];
      }
    }

    return `${fileName}.zip`;
  }
}
